/**
 * Created by joerg on 20.05.17.
 */
import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import Utils from '../utils/Utils';
import InputComponent from '../components/InputComponent';
import OutPutComponent from '../components/OutPutComponent';
import InputModel from '../models/InputModel'
import DropDown from '../components/DropDown'



@observer
export default class Kurzergebnis extends React.Component {

    _onChange(e,entry){
        console.log('ch',e.target.value,entry)
        entry.value = e.target.value;
    }
    componentDidUpdate(){
        setTimeout(()=>{requestAnimationFrame(this._calcwidths);},200);

    }
    componentDidMount(){
        this.componentDidUpdate();
    }
    _calcwidths(){
        console.log('calcwidth')





    }

    render (){
        const {baseDataStore,brespaAnalyseStore,halbfertigAnalyseStore,ortbetonAnalyseStore} = this.props;
      //  const self = this;
        var z = 200;
        return <div id="kurzergebnis" className="well">
            <h4>Ergebnis</h4>
            <hr/>
            <div className="kurzanalyse brespa">
                <h5>BRESPA Decke</h5>
                <table className="table table-condensed">
                    <tbody>
                        <tr><td>Kosten</td><td>{brespaAnalyseStore.totalValue.getFormattedVal()}</td><td>{brespaAnalyseStore.totalValue.einheit}</td></tr>
                    </tbody>
                </table>
            </div>
            <hr/>
            <div className="kurzanalyse filli">
                <h5>Halbfertigteildecke</h5>
                <table className="table table-condensed">
                    <tbody>
                    <tr><td>Kosten</td><td>{halbfertigAnalyseStore.totalValue.getFormattedVal()}</td><td>{halbfertigAnalyseStore.kosten_qm.einheit}</td></tr>
                    <tr><td>Kosten Dicke Brespa</td><td>{halbfertigAnalyseStore.totalValueBrespa.getFormattedVal()}</td><td>{halbfertigAnalyseStore.totalValueBrespa.einheit}</td></tr>
                    </tbody>
                </table>
            </div>
            <hr/>
            <div className="kurzanalyse ortbeton">
                <h5>Ortbetondecke</h5>
                <table className="table table-condensed">
                    <tbody>
                    <tr><td>Kosten</td><td>{ortbetonAnalyseStore.totalValue.getFormattedVal()}</td><td>{ortbetonAnalyseStore.kosten_qm.einheit}</td></tr>
                    <tr><td>Kosten Dicke Brespa</td><td>{ortbetonAnalyseStore.totalValueBrespa.getFormattedVal()}</td><td>{ortbetonAnalyseStore.totalValueBrespa.einheit}</td></tr>
                    </tbody>
                </table>
            </div>
        </div>;
    }

}

Kurzergebnis.propTypes = {
    baseDataStore: PropTypes.object.isRequired,
    brespaAnalyseStore:PropTypes.object.isRequired,
    halbfertigAnalyseStore:PropTypes.object.isRequired,
    ortbetonAnalyseStore: PropTypes.object.isRequired
}


// WEBPACK FOOTER //
// ./src/components/Kurzergebnis.js